import { useMemo } from 'react';
import { useObjectOperations } from './useObjectOperations';

export const useFacilityPageTitle = () => {
  const { object } = useObjectOperations();

  return useMemo(() => {
    if (object?.id) {
      return `Объект ${object.name}`;
    }
    return 'Создание объекта';
  }, [object?.name, object?.id]);
};
